/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */

/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import React from 'react';
import ReactDOM from 'react-dom';
import {
    BrowserRouter, // Route, Switch, useLocation,
} from 'react-router-dom';
import { Provider } from 'react-redux';
import { disableReactDevTools } from '@fvilers/disable-react-devtools';

import store from './redux/reducers/reducer';
import AppRoute from './components/routes';
import Meta from './components/common/Meta';
import AgeGate from './components/common/AgeGate';
import filterInjectedAndroidIabError from './utils/sentryBeforeSend';

require('./bootstrap');

const parsed = new URLSearchParams(window.location.search);
const mixEnv = process.env.MIX_APP_ENV ? process.env.MIX_APP_ENV.toString().toLowerCase() : 'staging';
const user = JSON.parse(localStorage.getItem('user'));

if (process.env.MIX_APP_ENV === 'production') {
    disableReactDevTools();
}

const initializeMonitoring = async () => {
    const [Sentry, tracing] = await Promise.all([
        import(/* webpackChunkName: "monitoring" */ '@sentry/react'),
        import(/* webpackChunkName: "monitoring" */ '@sentry/tracing'),
    ]);

    Sentry.init({
        dsn: 'https://611abe0f40314183a5e8f046757a3236@o1267404.ingest.sentry.io/6456372',
        integrations: [new tracing.BrowserTracing()],
        environment: mixEnv,
        tracesSampleRate: process.env.MIX_SENTRY_TRACES_SAMPLE_RATE,
        beforeSend: filterInjectedAndroidIabError,
        ignoreErrors: [
            'Network Error',
            'Request failed with status code 422',
            'NotAllowedError',
            'Non-Error promise rejection captured',
            'Non-Error exception captured',
            'Request aborted',
            'Request canceled',
            '402'
        ]
    });

    if (user && Object.keys(user).length > 0) {
        Sentry.setUser({ id: user.id, username: user.login });
    }
};

if (mixEnv === 'production') {
    window.addEventListener('load', () => {
        const startMonitoring = () => initializeMonitoring().catch(() => {});
        if ('requestIdleCallback' in window) {
            window.requestIdleCallback(startMonitoring);
        } else {
            window.setTimeout(startMonitoring, 0);
        }
    }, { once: true });
}

if (parsed.get('ref')) {
    localStorage.setItem('referrer', parsed.get('ref'));
}

const App = () => {
    return (
        <div className="wrapper main-app">
            <Meta />
            <Provider store={store}>
                <BrowserRouter>
                    <AgeGate><AppRoute /></AgeGate>
                </BrowserRouter>
            </Provider>
        </div>
    );
};

ReactDOM.render(
    <App />,
    document.getElementById('chat_cont'),
);
